import {Pipe, PipeTransform} from '@angular/core';
interface States {
  [x: string]: string;
}
export const MARK_UP_STATES = {
  normal: '正常',
  failure: '已失效',
  notStarted: '未开始',
  haveEnded: '已过期',
};

// CouponState {
//   normal
//   failure
//   notStarted
//   haveEnded
//   }
const TOTAL_STATES: {
  [x: string]: States;
} = {
  MARK_UP_STATES,
};

@Pipe({
  name: 'state',
})
export class StatePipe implements PipeTransform {
  transform(value: string, target?: string): string | undefined {
    if (target) {
      return TOTAL_STATES[target][value];
    }
    return {
      ...MARK_UP_STATES,
    }[value];
  }
}
